"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
var react_1 = __importStar(require("react"));
var Questionnaire_1 = require("../Questionnaire");
var Image_1 = __importDefault(require("../../elements/Image"));
var Loading = function (_a) {
    var question = _a.question, goToNextStep = _a.goToNextStep, isActive = _a.isActive;
    var goNextWithTimeout = function () {
        var r = Math.floor(Math.random() * (6000 - 4000) + 4000);
        setTimeout(function () {
            goToNextStep();
        }, r);
    };
    react_1.useEffect(function () {
        if (isActive)
            goNextWithTimeout();
    }, [isActive]);
    if (question.image)
        return (react_1.default.createElement(Questionnaire_1.ResponsiveImage, null, question.image.src.endsWith('.mp4') ? (react_1.default.createElement("video", { src: question.image.src, width: "360", autoPlay: true, loop: true, muted: true, playsInline: true })) : (react_1.default.createElement(Image_1.default, __assign({}, question.image)))));
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = Loading;
//# sourceMappingURL=Loading.js.map